(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4467"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4467"] = parcelRequire;
}
parcelRequire.register("2AfVR", function(module, exports) {

$parcel$export(module.exports, "Application", () => Application);
$parcel$export(module.exports, "Controller", () => Controller);
/*
Stimulus 3.2.1
Copyright © 2022 Basecamp, LLC
 */ class EventListener {
    constructor(eventTarget, eventName, eventOptions){
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    connect() {
        this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
    }
    disconnect() {
        this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
    }
    bindingConnected(binding) {
        this.unorderedBindings.add(binding);
    }
    bindingDisconnected(binding) {
        this.unorderedBindings.delete(binding);
    }
    handleEvent(event) {
        const extendedEvent = extendEvent(event);
        for (const binding of this.bindings){
            if (extendedEvent.immediatePropagationStopped) break;
            else binding.handleEvent(extendedEvent);
        }
    }
    hasBindings() {
        return this.unorderedBindings.size > 0;
    }
    get bindings() {
        return Array.from(this.unorderedBindings).sort((left, right)=>{
            const leftIndex = left.index, rightIndex = right.index;
            return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
        });
    }
}
function extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        const { stopImmediatePropagation  } = event;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation () {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
class Dispatcher {
    constructor(application){
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.eventListeners.forEach((eventListener)=>eventListener.connect());
        }
    }
    stop() {
        if (this.started) {
            this.started = false;
            this.eventListeners.forEach((eventListener)=>eventListener.disconnect());
        }
    }
    get eventListeners() {
        return Array.from(this.eventListenerMaps.values()).reduce((listeners, map)=>listeners.concat(Array.from(map.values())), []);
    }
    bindingConnected(binding) {
        this.fetchEventListenerForBinding(binding).bindingConnected(binding);
    }
    bindingDisconnected(binding, clearEventListeners = false) {
        this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
        if (clearEventListeners) this.clearEventListenersForBinding(binding);
    }
    handleError(error, message, detail = {}) {
        this.application.handleError(error, `Error ${message}`, detail);
    }
    clearEventListenersForBinding(binding) {
        const eventListener = this.fetchEventListenerForBinding(binding);
        if (!eventListener.hasBindings()) {
            eventListener.disconnect();
            this.removeMappedEventListenerFor(binding);
        }
    }
    removeMappedEventListenerFor(binding) {
        const { eventTarget , eventName , eventOptions  } = binding;
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        eventListenerMap.delete(cacheKey);
        if (eventListenerMap.size == 0) this.eventListenerMaps.delete(eventTarget);
    }
    fetchEventListenerForBinding(binding) {
        const { eventTarget , eventName , eventOptions  } = binding;
        return this.fetchEventListener(eventTarget, eventName, eventOptions);
    }
    fetchEventListener(eventTarget, eventName, eventOptions) {
        const eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
        const cacheKey = this.cacheKey(eventName, eventOptions);
        let eventListener = eventListenerMap.get(cacheKey);
        if (!eventListener) {
            eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
            eventListenerMap.set(cacheKey, eventListener);
        }
        return eventListener;
    }
    createEventListener(eventTarget, eventName, eventOptions) {
        const eventListener = new EventListener(eventTarget, eventName, eventOptions);
        if (this.started) eventListener.connect();
        return eventListener;
    }
    fetchEventListenerMapForEventTarget(eventTarget) {
        let eventListenerMap = this.eventListenerMaps.get(eventTarget);
        if (!eventListenerMap) {
            eventListenerMap = new Map();
            this.eventListenerMaps.set(eventTarget, eventListenerMap);
        }
        return eventListenerMap;
    }
    cacheKey(eventName, eventOptions) {
        const parts = [
            eventName
        ];
        Object.keys(eventOptions).sort().forEach((key)=>{
            parts.push(`${eventOptions[key] ? "" : "!"}${key}`);
        });
        return parts.join(":");
    }
}
const defaultActionDescriptorFilters = {
    stop ({ event , value  }) {
        if (value) event.stopPropagation();
        return true;
    },
    prevent ({ event , value  }) {
        if (value) event.preventDefault();
        return true;
    },
    self ({ event , value , element  }) {
        if (value) return element === event.target;
        else return true;
    }
};
const descriptorPattern = /^(?:(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function parseActionDescriptorString(descriptorString) {
    const source = descriptorString.trim();
    const matches = source.match(descriptorPattern) || [];
    let eventName = matches[1];
    let keyFilter = matches[2];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += `.${keyFilter}`;
        keyFilter = "";
    }
    return {
        eventTarget: parseEventTarget(matches[3]),
        eventName: eventName,
        eventOptions: matches[6] ? parseEventOptions(matches[6]) : {},
        identifier: matches[4],
        methodName: matches[5],
        keyFilter: keyFilter
    };
}
function parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce((options, token)=>Object.assign(options, {
            [token.replace(/^!/, "")]: !/^!/.test(token)
        }), {});
}
function stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, (_, char)=>char.toUpperCase());
}
function namespaceCamelize(value) {
    return camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function dasherize(value) {
    return value.replace(/([A-Z])/g, (_, char)=>`-${char.toLowerCase()}`);
}
function tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
class Action {
    constructor(element, index, descriptor, schema){
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || getDefaultEventNameForElement(element) || error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || error("missing identifier");
        this.methodName = descriptor.methodName || error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    static forToken(token, schema) {
        return new this(token.element, token.index, parseActionDescriptorString(token.content), schema);
    }
    toString() {
        const eventFilter = this.keyFilter ? `.${this.keyFilter}` : "";
        const eventTarget = this.eventTargetName ? `@${this.eventTargetName}` : "";
        return `${this.eventName}${eventFilter}${eventTarget}->${this.identifier}#${this.methodName}`;
    }
    isFilterTarget(event) {
        if (!this.keyFilter) return false;
        const filteres = this.keyFilter.split("+");
        const modifiers = [
            "meta",
            "ctrl",
            "alt",
            "shift"
        ];
        const [meta, ctrl, alt, shift] = modifiers.map((modifier)=>filteres.includes(modifier));
        if (event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift) return true;
        const standardFilter = filteres.filter((key)=>!modifiers.includes(key))[0];
        if (!standardFilter) return false;
        if (!Object.prototype.hasOwnProperty.call(this.keyMappings, standardFilter)) error(`contains unknown key filter: ${this.keyFilter}`);
        return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
    }
    get params() {
        const params = {};
        const pattern = new RegExp(`^data-${this.identifier}-(.+)-param$`, "i");
        for (const { name , value  } of Array.from(this.element.attributes)){
            const match = name.match(pattern);
            const key = match && match[1];
            if (key) params[camelize(key)] = typecast(value);
        }
        return params;
    }
    get eventTargetName() {
        return stringifyEventTarget(this.eventTarget);
    }
    get keyMappings() {
        return this.schema.keyMappings;
    }
}
const defaultEventNames = {
    a: ()=>"click",
    button: ()=>"click",
    form: ()=>"submit",
    details: ()=>"toggle",
    input: (e)=>e.getAttribute("type") == "submit" ? "click" : "input",
    select: ()=>"change",
    textarea: ()=>"input"
};
function getDefaultEventNameForElement(element) {
    const tagName = element.tagName.toLowerCase();
    if (tagName in defaultEventNames) return defaultEventNames[tagName](element);
}
function error(message) {
    throw new Error(message);
}
function typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
class Binding {
    constructor(context, action){
        this.context = context;
        this.action = action;
    }
    get index() {
        return this.action.index;
    }
    get eventTarget() {
        return this.action.eventTarget;
    }
    get eventOptions() {
        return this.action.eventOptions;
    }
    get identifier() {
        return this.context.identifier;
    }
    handleEvent(event) {
        if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(event)) this.invokeWithEvent(event);
    }
    get eventName() {
        return this.action.eventName;
    }
    get method() {
        const method = this.controller[this.methodName];
        if (typeof method == "function") return method;
        throw new Error(`Action "${this.action}" references undefined method "${this.methodName}"`);
    }
    applyEventModifiers(event) {
        const { element  } = this.action;
        const { actionDescriptorFilters  } = this.context.application;
        let passes = true;
        for (const [name, value] of Object.entries(this.eventOptions)){
            if (name in actionDescriptorFilters) {
                const filter = actionDescriptorFilters[name];
                passes = passes && filter({
                    name: name,
                    value: value,
                    event: event,
                    element: element
                });
            } else continue;
        }
        return passes;
    }
    invokeWithEvent(event) {
        const { target , currentTarget  } = event;
        try {
            const { params  } = this.action;
            const actionEvent = Object.assign(event, {
                params: params
            });
            this.method.call(this.controller, actionEvent);
            this.context.logDebugActivity(this.methodName, {
                event: event,
                target: target,
                currentTarget: currentTarget,
                action: this.methodName
            });
        } catch (error) {
            const { identifier , controller , element , index  } = this;
            const detail = {
                identifier: identifier,
                controller: controller,
                element: element,
                index: index,
                event: event
            };
            this.context.handleError(error, `invoking action "${this.action}"`, detail);
        }
    }
    willBeInvokedByEvent(event) {
        const eventTarget = event.target;
        if (event instanceof KeyboardEvent && this.action.isFilterTarget(event)) return false;
        if (this.element === eventTarget) return true;
        else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
        else return this.scope.containsElement(this.action.element);
    }
    get controller() {
        return this.context.controller;
    }
    get methodName() {
        return this.action.methodName;
    }
    get element() {
        return this.scope.element;
    }
    get scope() {
        return this.context.scope;
    }
}
class ElementObserver {
    constructor(element, delegate){
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.refresh();
        }
    }
    pause(callback) {
        if (this.started) {
            this.mutationObserver.disconnect();
            this.started = false;
        }
        callback();
        if (!this.started) {
            this.mutationObserver.observe(this.element, this.mutationObserverInit);
            this.started = true;
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) {
            const matches = new Set(this.matchElementsInTree());
            for (const element of Array.from(this.elements))if (!matches.has(element)) this.removeElement(element);
            for (const element of Array.from(matches))this.addElement(element);
        }
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
        else if (mutation.type == "childList") {
            this.processRemovedNodes(mutation.removedNodes);
            this.processAddedNodes(mutation.addedNodes);
        }
    }
    processAttributeChange(node, attributeName) {
        const element = node;
        if (this.elements.has(element)) {
            if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
            else this.removeElement(element);
        } else if (this.matchElement(element)) this.addElement(element);
    }
    processRemovedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element) this.processTree(element, this.removeElement);
        }
    }
    processAddedNodes(nodes) {
        for (const node of Array.from(nodes)){
            const element = this.elementFromNode(node);
            if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
        }
    }
    matchElement(element) {
        return this.delegate.matchElement(element);
    }
    matchElementsInTree(tree = this.element) {
        return this.delegate.matchElementsInTree(tree);
    }
    processTree(tree, processor) {
        for (const element of this.matchElementsInTree(tree))processor.call(this, element);
    }
    elementFromNode(node) {
        if (node.nodeType == Node.ELEMENT_NODE) return node;
    }
    elementIsActive(element) {
        if (element.isConnected != this.element.isConnected) return false;
        else return this.element.contains(element);
    }
    addElement(element) {
        if (!this.elements.has(element)) {
            if (this.elementIsActive(element)) {
                this.elements.add(element);
                if (this.delegate.elementMatched) this.delegate.elementMatched(element);
            }
        }
    }
    removeElement(element) {
        if (this.elements.has(element)) {
            this.elements.delete(element);
            if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
        }
    }
}
class AttributeObserver {
    constructor(element, attributeName, delegate){
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new ElementObserver(element, this);
    }
    get element() {
        return this.elementObserver.element;
    }
    get selector() {
        return `[${this.attributeName}]`;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get started() {
        return this.elementObserver.started;
    }
    matchElement(element) {
        return element.hasAttribute(this.attributeName);
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector));
        return match.concat(matches);
    }
    elementMatched(element) {
        if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
    }
    elementUnmatched(element) {
        if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
    }
    elementAttributeChanged(element, attributeName) {
        if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
    }
}
function add(map, key, value) {
    fetch(map, key).add(value);
}
function del(map, key, value) {
    fetch(map, key).delete(value);
    prune(map, key);
}
function fetch(map, key) {
    let values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function prune(map, key) {
    const values = map.get(key);
    if (values != null && values.size == 0) map.delete(key);
}
class Multimap {
    constructor(){
        this.valuesByKey = new Map();
    }
    get keys() {
        return Array.from(this.valuesByKey.keys());
    }
    get values() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((values, set)=>values.concat(Array.from(set)), []);
    }
    get size() {
        const sets = Array.from(this.valuesByKey.values());
        return sets.reduce((size, set)=>size + set.size, 0);
    }
    add(key, value) {
        add(this.valuesByKey, key, value);
    }
    delete(key, value) {
        del(this.valuesByKey, key, value);
    }
    has(key, value) {
        const values = this.valuesByKey.get(key);
        return values != null && values.has(value);
    }
    hasKey(key) {
        return this.valuesByKey.has(key);
    }
    hasValue(value) {
        const sets = Array.from(this.valuesByKey.values());
        return sets.some((set)=>set.has(value));
    }
    getValuesForKey(key) {
        const values = this.valuesByKey.get(key);
        return values ? Array.from(values) : [];
    }
    getKeysForValue(value) {
        return Array.from(this.valuesByKey).filter(([_key, values])=>values.has(value)).map(([key, _values])=>key);
    }
}
class IndexedMultimap extends Multimap {
    constructor(){
        super();
        this.keysByValue = new Map();
    }
    get values() {
        return Array.from(this.keysByValue.keys());
    }
    add(key, value) {
        super.add(key, value);
        add(this.keysByValue, value, key);
    }
    delete(key, value) {
        super.delete(key, value);
        del(this.keysByValue, value, key);
    }
    hasValue(value) {
        return this.keysByValue.has(value);
    }
    getKeysForValue(value) {
        const set = this.keysByValue.get(value);
        return set ? Array.from(set) : [];
    }
}
class SelectorObserver {
    constructor(element, selector, delegate, details = {}){
        this.selector = selector;
        this.details = details;
        this.elementObserver = new ElementObserver(element, this);
        this.delegate = delegate;
        this.matchesByElement = new Multimap();
    }
    get started() {
        return this.elementObserver.started;
    }
    start() {
        this.elementObserver.start();
    }
    pause(callback) {
        this.elementObserver.pause(callback);
    }
    stop() {
        this.elementObserver.stop();
    }
    refresh() {
        this.elementObserver.refresh();
    }
    get element() {
        return this.elementObserver.element;
    }
    matchElement(element) {
        const matches = element.matches(this.selector);
        if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
        return matches;
    }
    matchElementsInTree(tree) {
        const match = this.matchElement(tree) ? [
            tree
        ] : [];
        const matches = Array.from(tree.querySelectorAll(this.selector)).filter((match)=>this.matchElement(match));
        return match.concat(matches);
    }
    elementMatched(element) {
        this.selectorMatched(element);
    }
    elementUnmatched(element) {
        this.selectorUnmatched(element);
    }
    elementAttributeChanged(element, _attributeName) {
        const matches = this.matchElement(element);
        const matchedBefore = this.matchesByElement.has(this.selector, element);
        if (!matches && matchedBefore) this.selectorUnmatched(element);
    }
    selectorMatched(element) {
        if (this.delegate.selectorMatched) {
            this.delegate.selectorMatched(element, this.selector, this.details);
            this.matchesByElement.add(this.selector, element);
        }
    }
    selectorUnmatched(element) {
        this.delegate.selectorUnmatched(element, this.selector, this.details);
        this.matchesByElement.delete(this.selector, element);
    }
}
class StringMapObserver {
    constructor(element, delegate){
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver((mutations)=>this.processMutations(mutations));
    }
    start() {
        if (!this.started) {
            this.started = true;
            this.mutationObserver.observe(this.element, {
                attributes: true,
                attributeOldValue: true
            });
            this.refresh();
        }
    }
    stop() {
        if (this.started) {
            this.mutationObserver.takeRecords();
            this.mutationObserver.disconnect();
            this.started = false;
        }
    }
    refresh() {
        if (this.started) for (const attributeName of this.knownAttributeNames)this.refreshAttribute(attributeName, null);
    }
    processMutations(mutations) {
        if (this.started) for (const mutation of mutations)this.processMutation(mutation);
    }
    processMutation(mutation) {
        const attributeName = mutation.attributeName;
        if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
    }
    refreshAttribute(attributeName, oldValue) {
        const key = this.delegate.getStringMapKeyForAttribute(attributeName);
        if (key != null) {
            if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
            const value = this.element.getAttribute(attributeName);
            if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
            if (value == null) {
                const oldValue = this.stringMap.get(attributeName);
                this.stringMap.delete(attributeName);
                if (oldValue) this.stringMapKeyRemoved(key, attributeName, oldValue);
            } else this.stringMap.set(attributeName, value);
        }
    }
    stringMapKeyAdded(key, attributeName) {
        if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
    }
    stringMapValueChanged(value, key, oldValue) {
        if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
    }
    get knownAttributeNames() {
        return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
    }
    get currentAttributeNames() {
        return Array.from(this.element.attributes).map((attribute)=>attribute.name);
    }
    get recordedAttributeNames() {
        return Array.from(this.stringMap.keys());
    }
}
class TokenListObserver {
    constructor(element, attributeName, delegate){
        this.attributeObserver = new AttributeObserver(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new Multimap();
    }
    get started() {
        return this.attributeObserver.started;
    }
    start() {
        this.attributeObserver.start();
    }
    pause(callback) {
        this.attributeObserver.pause(callback);
    }
    stop() {
        this.attributeObserver.stop();
    }
    refresh() {
        this.attributeObserver.refresh();
    }
    get element() {
        return this.attributeObserver.element;
    }
    get attributeName() {
        return this.attributeObserver.attributeName;
    }
    elementMatchedAttribute(element) {
        this.tokensMatched(this.readTokensForElement(element));
    }
    elementAttributeValueChanged(element) {
        const [unmatchedTokens, matchedTokens] = this.refreshTokensForElement(element);
        this.tokensUnmatched(unmatchedTokens);
        this.tokensMatched(matchedTokens);
    }
    elementUnmatchedAttribute(element) {
        this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
    }
    tokensMatched(tokens) {
        tokens.forEach((token)=>this.tokenMatched(token));
    }
    tokensUnmatched(tokens) {
        tokens.forEach((token)=>this.tokenUnmatched(token));
    }
    tokenMatched(token) {
        this.delegate.tokenMatched(token);
        this.tokensByElement.add(token.element, token);
    }
    tokenUnmatched(token) {
        this.delegate.tokenUnmatched(token);
        this.tokensByElement.delete(token.element, token);
    }
    refreshTokensForElement(element) {
        const previousTokens = this.tokensByElement.getValuesForKey(element);
        const currentTokens = this.readTokensForElement(element);
        const firstDifferingIndex = zip(previousTokens, currentTokens).findIndex(([previousToken, currentToken])=>!tokensAreEqual(previousToken, currentToken));
        if (firstDifferingIndex == -1) return [
            [],
            []
        ];
        else return [
            previousTokens.slice(firstDifferingIndex),
            currentTokens.slice(firstDifferingIndex)
        ];
    }
    readTokensForElement(element) {
        const attributeName = this.attributeName;
        const tokenString = element.getAttribute(attributeName) || "";
        return parseTokenString(tokenString, element, attributeName);
    }
}
function parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter((content)=>content.length).map((content, index)=>({
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        }));
}
function zip(left, right) {
    const length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, (_, index)=>[
            left[index],
            right[index]
        ]);
}
function tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
class ValueListObserver {
    constructor(element, attributeName, delegate){
        this.tokenListObserver = new TokenListObserver(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    get started() {
        return this.tokenListObserver.started;
    }
    start() {
        this.tokenListObserver.start();
    }
    stop() {
        this.tokenListObserver.stop();
    }
    refresh() {
        this.tokenListObserver.refresh();
    }
    get element() {
        return this.tokenListObserver.element;
    }
    get attributeName() {
        return this.tokenListObserver.attributeName;
    }
    tokenMatched(token) {
        const { element  } = token;
        const { value  } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).set(token, value);
            this.delegate.elementMatchedValue(element, value);
        }
    }
    tokenUnmatched(token) {
        const { element  } = token;
        const { value  } = this.fetchParseResultForToken(token);
        if (value) {
            this.fetchValuesByTokenForElement(element).delete(token);
            this.delegate.elementUnmatchedValue(element, value);
        }
    }
    fetchParseResultForToken(token) {
        let parseResult = this.parseResultsByToken.get(token);
        if (!parseResult) {
            parseResult = this.parseToken(token);
            this.parseResultsByToken.set(token, parseResult);
        }
        return parseResult;
    }
    fetchValuesByTokenForElement(element) {
        let valuesByToken = this.valuesByTokenByElement.get(element);
        if (!valuesByToken) {
            valuesByToken = new Map();
            this.valuesByTokenByElement.set(element, valuesByToken);
        }
        return valuesByToken;
    }
    parseToken(token) {
        try {
            const value = this.delegate.parseValueForToken(token);
            return {
                value: value
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class BindingObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    start() {
        if (!this.valueListObserver) {
            this.valueListObserver = new ValueListObserver(this.element, this.actionAttribute, this);
            this.valueListObserver.start();
        }
    }
    stop() {
        if (this.valueListObserver) {
            this.valueListObserver.stop();
            delete this.valueListObserver;
            this.disconnectAllActions();
        }
    }
    get element() {
        return this.context.element;
    }
    get identifier() {
        return this.context.identifier;
    }
    get actionAttribute() {
        return this.schema.actionAttribute;
    }
    get schema() {
        return this.context.schema;
    }
    get bindings() {
        return Array.from(this.bindingsByAction.values());
    }
    connectAction(action) {
        const binding = new Binding(this.context, action);
        this.bindingsByAction.set(action, binding);
        this.delegate.bindingConnected(binding);
    }
    disconnectAction(action) {
        const binding = this.bindingsByAction.get(action);
        if (binding) {
            this.bindingsByAction.delete(action);
            this.delegate.bindingDisconnected(binding);
        }
    }
    disconnectAllActions() {
        this.bindings.forEach((binding)=>this.delegate.bindingDisconnected(binding, true));
        this.bindingsByAction.clear();
    }
    parseValueForToken(token) {
        const action = Action.forToken(token, this.schema);
        if (action.identifier == this.identifier) return action;
    }
    elementMatchedValue(element, action) {
        this.connectAction(action);
    }
    elementUnmatchedValue(element, action) {
        this.disconnectAction(action);
    }
}
class ValueObserver {
    constructor(context, receiver){
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new StringMapObserver(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    start() {
        this.stringMapObserver.start();
        this.invokeChangedCallbacksForDefaultValues();
    }
    stop() {
        this.stringMapObserver.stop();
    }
    get element() {
        return this.context.element;
    }
    get controller() {
        return this.context.controller;
    }
    getStringMapKeyForAttribute(attributeName) {
        if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
    }
    stringMapKeyAdded(key, attributeName) {
        const descriptor = this.valueDescriptorMap[attributeName];
        if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
    }
    stringMapValueChanged(value, name, oldValue) {
        const descriptor = this.valueDescriptorNameMap[name];
        if (value === null) return;
        if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
        this.invokeChangedCallback(name, value, oldValue);
    }
    stringMapKeyRemoved(key, attributeName, oldValue) {
        const descriptor = this.valueDescriptorNameMap[key];
        if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
        else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
    }
    invokeChangedCallbacksForDefaultValues() {
        for (const { key , name , defaultValue , writer  } of this.valueDescriptors)if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
    }
    invokeChangedCallback(name, rawValue, rawOldValue) {
        const changedMethodName = `${name}Changed`;
        const changedMethod = this.receiver[changedMethodName];
        if (typeof changedMethod == "function") {
            const descriptor = this.valueDescriptorNameMap[name];
            try {
                const value = descriptor.reader(rawValue);
                let oldValue = rawOldValue;
                if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                changedMethod.call(this.receiver, value, oldValue);
            } catch (error) {
                if (error instanceof TypeError) error.message = `Stimulus Value "${this.context.identifier}.${descriptor.name}" - ${error.message}`;
                throw error;
            }
        }
    }
    get valueDescriptors() {
        const { valueDescriptorMap  } = this;
        return Object.keys(valueDescriptorMap).map((key)=>valueDescriptorMap[key]);
    }
    get valueDescriptorNameMap() {
        const descriptors = {};
        Object.keys(this.valueDescriptorMap).forEach((key)=>{
            const descriptor = this.valueDescriptorMap[key];
            descriptors[descriptor.name] = descriptor;
        });
        return descriptors;
    }
    hasValue(attributeName) {
        const descriptor = this.valueDescriptorNameMap[attributeName];
        const hasMethodName = `has${capitalize(descriptor.name)}`;
        return this.receiver[hasMethodName];
    }
}
class TargetObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new Multimap();
    }
    start() {
        if (!this.tokenListObserver) {
            this.tokenListObserver = new TokenListObserver(this.element, this.attributeName, this);
            this.tokenListObserver.start();
        }
    }
    stop() {
        if (this.tokenListObserver) {
            this.disconnectAllTargets();
            this.tokenListObserver.stop();
            delete this.tokenListObserver;
        }
    }
    tokenMatched({ element , content: name  }) {
        if (this.scope.containsElement(element)) this.connectTarget(element, name);
    }
    tokenUnmatched({ element , content: name  }) {
        this.disconnectTarget(element, name);
    }
    connectTarget(element, name) {
        var _a;
        if (!this.targetsByName.has(name, element)) {
            this.targetsByName.add(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetConnected(element, name));
        }
    }
    disconnectTarget(element, name) {
        var _a;
        if (this.targetsByName.has(name, element)) {
            this.targetsByName.delete(name, element);
            (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(()=>this.delegate.targetDisconnected(element, name));
        }
    }
    disconnectAllTargets() {
        for (const name of this.targetsByName.keys)for (const element of this.targetsByName.getValuesForKey(name))this.disconnectTarget(element, name);
    }
    get attributeName() {
        return `data-${this.context.identifier}-target`;
    }
    get element() {
        return this.context.element;
    }
    get scope() {
        return this.context.scope;
    }
}
function readInheritableStaticArrayValues(constructor, propertyName) {
    const ancestors = getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce((values, constructor)=>{
        getOwnStaticArrayValues(constructor, propertyName).forEach((name)=>values.add(name));
        return values;
    }, new Set()));
}
function readInheritableStaticObjectPairs(constructor, propertyName) {
    const ancestors = getAncestorsForConstructor(constructor);
    return ancestors.reduce((pairs, constructor)=>{
        pairs.push(...getOwnStaticObjectPairs(constructor, propertyName));
        return pairs;
    }, []);
}
function getAncestorsForConstructor(constructor) {
    const ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function getOwnStaticArrayValues(constructor, propertyName) {
    const definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function getOwnStaticObjectPairs(constructor, propertyName) {
    const definition = constructor[propertyName];
    return definition ? Object.keys(definition).map((key)=>[
            key,
            definition[key]
        ]) : [];
}
class OutletObserver {
    constructor(context, delegate){
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new Multimap();
        this.outletElementsByName = new Multimap();
        this.selectorObserverMap = new Map();
    }
    start() {
        if (this.selectorObserverMap.size === 0) {
            this.outletDefinitions.forEach((outletName)=>{
                const selector = this.selector(outletName);
                const details = {
                    outletName: outletName
                };
                if (selector) this.selectorObserverMap.set(outletName, new SelectorObserver(document.body, selector, this, details));
            });
            this.selectorObserverMap.forEach((observer)=>observer.start());
        }
        this.dependentContexts.forEach((context)=>context.refresh());
    }
    stop() {
        if (this.selectorObserverMap.size > 0) {
            this.disconnectAllOutlets();
            this.selectorObserverMap.forEach((observer)=>observer.stop());
            this.selectorObserverMap.clear();
        }
    }
    refresh() {
        this.selectorObserverMap.forEach((observer)=>observer.refresh());
    }
    selectorMatched(element, _selector, { outletName  }) {
        const outlet = this.getOutlet(element, outletName);
        if (outlet) this.connectOutlet(outlet, element, outletName);
    }
    selectorUnmatched(element, _selector, { outletName  }) {
        const outlet = this.getOutletFromMap(element, outletName);
        if (outlet) this.disconnectOutlet(outlet, element, outletName);
    }
    selectorMatchElement(element, { outletName  }) {
        return this.hasOutlet(element, outletName) && element.matches(`[${this.context.application.schema.controllerAttribute}~=${outletName}]`);
    }
    connectOutlet(outlet, element, outletName) {
        var _a;
        if (!this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.add(outletName, outlet);
            this.outletElementsByName.add(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletConnected(outlet, element, outletName));
        }
    }
    disconnectOutlet(outlet, element, outletName) {
        var _a;
        if (this.outletElementsByName.has(outletName, element)) {
            this.outletsByName.delete(outletName, outlet);
            this.outletElementsByName.delete(outletName, element);
            (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(()=>this.delegate.outletDisconnected(outlet, element, outletName));
        }
    }
    disconnectAllOutlets() {
        for (const outletName of this.outletElementsByName.keys){
            for (const element of this.outletElementsByName.getValuesForKey(outletName))for (const outlet of this.outletsByName.getValuesForKey(outletName))this.disconnectOutlet(outlet, element, outletName);
        }
    }
    selector(outletName) {
        return this.scope.outlets.getSelectorForOutletName(outletName);
    }
    get outletDependencies() {
        const dependencies = new Multimap();
        this.router.modules.forEach((module)=>{
            const constructor = module.definition.controllerConstructor;
            const outlets = readInheritableStaticArrayValues(constructor, "outlets");
            outlets.forEach((outlet)=>dependencies.add(outlet, module.identifier));
        });
        return dependencies;
    }
    get outletDefinitions() {
        return this.outletDependencies.getKeysForValue(this.identifier);
    }
    get dependentControllerIdentifiers() {
        return this.outletDependencies.getValuesForKey(this.identifier);
    }
    get dependentContexts() {
        const identifiers = this.dependentControllerIdentifiers;
        return this.router.contexts.filter((context)=>identifiers.includes(context.identifier));
    }
    hasOutlet(element, outletName) {
        return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
    }
    getOutlet(element, outletName) {
        return this.application.getControllerForElementAndIdentifier(element, outletName);
    }
    getOutletFromMap(element, outletName) {
        return this.outletsByName.getValuesForKey(outletName).find((outlet)=>outlet.element === element);
    }
    get scope() {
        return this.context.scope;
    }
    get identifier() {
        return this.context.identifier;
    }
    get application() {
        return this.context.application;
    }
    get router() {
        return this.application.router;
    }
}
class Context {
    constructor(module, scope){
        this.logDebugActivity = (functionName, detail = {})=>{
            const { identifier , controller , element  } = this;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            this.application.logDebugActivity(this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new BindingObserver(this, this.dispatcher);
        this.valueObserver = new ValueObserver(this, this.controller);
        this.targetObserver = new TargetObserver(this, this);
        this.outletObserver = new OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    connect() {
        this.bindingObserver.start();
        this.valueObserver.start();
        this.targetObserver.start();
        this.outletObserver.start();
        try {
            this.controller.connect();
            this.logDebugActivity("connect");
        } catch (error) {
            this.handleError(error, "connecting controller");
        }
    }
    refresh() {
        this.outletObserver.refresh();
    }
    disconnect() {
        try {
            this.controller.disconnect();
            this.logDebugActivity("disconnect");
        } catch (error) {
            this.handleError(error, "disconnecting controller");
        }
        this.outletObserver.stop();
        this.targetObserver.stop();
        this.valueObserver.stop();
        this.bindingObserver.stop();
    }
    get application() {
        return this.module.application;
    }
    get identifier() {
        return this.module.identifier;
    }
    get schema() {
        return this.application.schema;
    }
    get dispatcher() {
        return this.application.dispatcher;
    }
    get element() {
        return this.scope.element;
    }
    get parentElement() {
        return this.element.parentElement;
    }
    handleError(error, message, detail = {}) {
        const { identifier , controller , element  } = this;
        detail = Object.assign({
            identifier: identifier,
            controller: controller,
            element: element
        }, detail);
        this.application.handleError(error, `Error ${message}`, detail);
    }
    targetConnected(element, name) {
        this.invokeControllerMethod(`${name}TargetConnected`, element);
    }
    targetDisconnected(element, name) {
        this.invokeControllerMethod(`${name}TargetDisconnected`, element);
    }
    outletConnected(outlet, element, name) {
        this.invokeControllerMethod(`${namespaceCamelize(name)}OutletConnected`, outlet, element);
    }
    outletDisconnected(outlet, element, name) {
        this.invokeControllerMethod(`${namespaceCamelize(name)}OutletDisconnected`, outlet, element);
    }
    invokeControllerMethod(methodName, ...args) {
        const controller = this.controller;
        if (typeof controller[methodName] == "function") controller[methodName](...args);
    }
}
function bless(constructor) {
    return shadow(constructor, getBlessedProperties(constructor));
}
function shadow(constructor, properties) {
    const shadowConstructor = extend(constructor);
    const shadowProperties = getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function getBlessedProperties(constructor) {
    const blessings = readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce((blessedProperties, blessing)=>{
        const properties = blessing(constructor);
        for(const key in properties){
            const descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function getShadowProperties(prototype, properties) {
    return getOwnKeys(properties).reduce((shadowProperties, key)=>{
        const descriptor = getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, {
            [key]: descriptor
        });
        return shadowProperties;
    }, {});
}
function getShadowedDescriptor(prototype, properties, key) {
    const shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    const shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        const descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
const getOwnKeys = (()=>{
    if (typeof Object.getOwnPropertySymbols == "function") return (object)=>[
            ...Object.getOwnPropertyNames(object),
            ...Object.getOwnPropertySymbols(object)
        ];
    else return Object.getOwnPropertyNames;
})();
const extend = (()=>{
    function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, new.target);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    }
    function testReflectExtension() {
        const a = function() {
            this.a.call(this);
        };
        const b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    }
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return (constructor)=>class extended extends constructor {
            };
    }
})();
function blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: bless(definition.controllerConstructor)
    };
}
class Module {
    constructor(application, definition){
        this.application = application;
        this.definition = blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    get identifier() {
        return this.definition.identifier;
    }
    get controllerConstructor() {
        return this.definition.controllerConstructor;
    }
    get contexts() {
        return Array.from(this.connectedContexts);
    }
    connectContextForScope(scope) {
        const context = this.fetchContextForScope(scope);
        this.connectedContexts.add(context);
        context.connect();
    }
    disconnectContextForScope(scope) {
        const context = this.contextsByScope.get(scope);
        if (context) {
            this.connectedContexts.delete(context);
            context.disconnect();
        }
    }
    fetchContextForScope(scope) {
        let context = this.contextsByScope.get(scope);
        if (!context) {
            context = new Context(this, scope);
            this.contextsByScope.set(scope, context);
        }
        return context;
    }
}
class ClassMap {
    constructor(scope){
        this.scope = scope;
    }
    has(name) {
        return this.data.has(this.getDataKey(name));
    }
    get(name) {
        return this.getAll(name)[0];
    }
    getAll(name) {
        const tokenString = this.data.get(this.getDataKey(name)) || "";
        return tokenize(tokenString);
    }
    getAttributeName(name) {
        return this.data.getAttributeNameForKey(this.getDataKey(name));
    }
    getDataKey(name) {
        return `${name}-class`;
    }
    get data() {
        return this.scope.data;
    }
}
class DataMap {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.getAttribute(name);
    }
    set(key, value) {
        const name = this.getAttributeNameForKey(key);
        this.element.setAttribute(name, value);
        return this.get(key);
    }
    has(key) {
        const name = this.getAttributeNameForKey(key);
        return this.element.hasAttribute(name);
    }
    delete(key) {
        if (this.has(key)) {
            const name = this.getAttributeNameForKey(key);
            this.element.removeAttribute(name);
            return true;
        } else return false;
    }
    getAttributeNameForKey(key) {
        return `data-${this.identifier}-${dasherize(key)}`;
    }
}
class Guide {
    constructor(logger){
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    warn(object, key, message) {
        let warnedKeys = this.warnedKeysByObject.get(object);
        if (!warnedKeys) {
            warnedKeys = new Set();
            this.warnedKeysByObject.set(object, warnedKeys);
        }
        if (!warnedKeys.has(key)) {
            warnedKeys.add(key);
            this.logger.warn(message, object);
        }
    }
}
function attributeValueContainsToken(attributeName, token) {
    return `[${attributeName}~="${token}"]`;
}
class TargetSet {
    constructor(scope){
        this.scope = scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(targetName) {
        return this.find(targetName) != null;
    }
    find(...targetNames) {
        return targetNames.reduce((target, targetName)=>target || this.findTarget(targetName) || this.findLegacyTarget(targetName), undefined);
    }
    findAll(...targetNames) {
        return targetNames.reduce((targets, targetName)=>[
                ...targets,
                ...this.findAllTargets(targetName),
                ...this.findAllLegacyTargets(targetName)
            ], []);
    }
    findTarget(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findElement(selector);
    }
    findAllTargets(targetName) {
        const selector = this.getSelectorForTargetName(targetName);
        return this.scope.findAllElements(selector);
    }
    getSelectorForTargetName(targetName) {
        const attributeName = this.schema.targetAttributeForScope(this.identifier);
        return attributeValueContainsToken(attributeName, targetName);
    }
    findLegacyTarget(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.deprecate(this.scope.findElement(selector), targetName);
    }
    findAllLegacyTargets(targetName) {
        const selector = this.getLegacySelectorForTargetName(targetName);
        return this.scope.findAllElements(selector).map((element)=>this.deprecate(element, targetName));
    }
    getLegacySelectorForTargetName(targetName) {
        const targetDescriptor = `${this.identifier}.${targetName}`;
        return attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
    }
    deprecate(element, targetName) {
        if (element) {
            const { identifier  } = this;
            const attributeName = this.schema.targetAttribute;
            const revisedAttributeName = this.schema.targetAttributeForScope(identifier);
            this.guide.warn(element, `target:${targetName}`, `Please replace ${attributeName}="${identifier}.${targetName}" with ${revisedAttributeName}="${targetName}". ` + `The ${attributeName} attribute is deprecated and will be removed in a future version of Stimulus.`);
        }
        return element;
    }
    get guide() {
        return this.scope.guide;
    }
}
class OutletSet {
    constructor(scope, controllerElement){
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get schema() {
        return this.scope.schema;
    }
    has(outletName) {
        return this.find(outletName) != null;
    }
    find(...outletNames) {
        return outletNames.reduce((outlet, outletName)=>outlet || this.findOutlet(outletName), undefined);
    }
    findAll(...outletNames) {
        return outletNames.reduce((outlets, outletName)=>[
                ...outlets,
                ...this.findAllOutlets(outletName)
            ], []);
    }
    getSelectorForOutletName(outletName) {
        const attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
        return this.controllerElement.getAttribute(attributeName);
    }
    findOutlet(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        if (selector) return this.findElement(selector, outletName);
    }
    findAllOutlets(outletName) {
        const selector = this.getSelectorForOutletName(outletName);
        return selector ? this.findAllElements(selector, outletName) : [];
    }
    findElement(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName))[0];
    }
    findAllElements(selector, outletName) {
        const elements = this.scope.queryElements(selector);
        return elements.filter((element)=>this.matchesElement(element, selector, outletName));
    }
    matchesElement(element, selector, outletName) {
        const controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
        return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
    }
}
class Scope {
    constructor(schema, element, identifier, logger){
        this.targets = new TargetSet(this);
        this.classes = new ClassMap(this);
        this.data = new DataMap(this);
        this.containsElement = (element)=>{
            return element.closest(this.controllerSelector) === this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new Guide(logger);
        this.outlets = new OutletSet(this.documentScope, element);
    }
    findElement(selector) {
        return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
    }
    findAllElements(selector) {
        return [
            ...this.element.matches(selector) ? [
                this.element
            ] : [],
            ...this.queryElements(selector).filter(this.containsElement)
        ];
    }
    queryElements(selector) {
        return Array.from(this.element.querySelectorAll(selector));
    }
    get controllerSelector() {
        return attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
    }
    get isDocumentScope() {
        return this.element === document.documentElement;
    }
    get documentScope() {
        return this.isDocumentScope ? this : new Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
    }
}
class ScopeObserver {
    constructor(element, schema, delegate){
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new ValueListObserver(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    start() {
        this.valueListObserver.start();
    }
    stop() {
        this.valueListObserver.stop();
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    parseValueForToken(token) {
        const { element , content: identifier  } = token;
        const scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
        let scope = scopesByIdentifier.get(identifier);
        if (!scope) {
            scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
            scopesByIdentifier.set(identifier, scope);
        }
        return scope;
    }
    elementMatchedValue(element, value) {
        const referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
        this.scopeReferenceCounts.set(value, referenceCount);
        if (referenceCount == 1) this.delegate.scopeConnected(value);
    }
    elementUnmatchedValue(element, value) {
        const referenceCount = this.scopeReferenceCounts.get(value);
        if (referenceCount) {
            this.scopeReferenceCounts.set(value, referenceCount - 1);
            if (referenceCount == 1) this.delegate.scopeDisconnected(value);
        }
    }
    fetchScopesByIdentifierForElement(element) {
        let scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
        if (!scopesByIdentifier) {
            scopesByIdentifier = new Map();
            this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
        }
        return scopesByIdentifier;
    }
}
class Router {
    constructor(application){
        this.application = application;
        this.scopeObserver = new ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new Multimap();
        this.modulesByIdentifier = new Map();
    }
    get element() {
        return this.application.element;
    }
    get schema() {
        return this.application.schema;
    }
    get logger() {
        return this.application.logger;
    }
    get controllerAttribute() {
        return this.schema.controllerAttribute;
    }
    get modules() {
        return Array.from(this.modulesByIdentifier.values());
    }
    get contexts() {
        return this.modules.reduce((contexts, module)=>contexts.concat(module.contexts), []);
    }
    start() {
        this.scopeObserver.start();
    }
    stop() {
        this.scopeObserver.stop();
    }
    loadDefinition(definition) {
        this.unloadIdentifier(definition.identifier);
        const module = new Module(this.application, definition);
        this.connectModule(module);
        const afterLoad = definition.controllerConstructor.afterLoad;
        if (afterLoad) afterLoad(definition.identifier, this.application);
    }
    unloadIdentifier(identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) this.disconnectModule(module);
    }
    getContextForElementAndIdentifier(element, identifier) {
        const module = this.modulesByIdentifier.get(identifier);
        if (module) return module.contexts.find((context)=>context.element == element);
    }
    handleError(error, message, detail) {
        this.application.handleError(error, message, detail);
    }
    createScopeForElementAndIdentifier(element, identifier) {
        return new Scope(this.schema, element, identifier, this.logger);
    }
    scopeConnected(scope) {
        this.scopesByIdentifier.add(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.connectContextForScope(scope);
    }
    scopeDisconnected(scope) {
        this.scopesByIdentifier.delete(scope.identifier, scope);
        const module = this.modulesByIdentifier.get(scope.identifier);
        if (module) module.disconnectContextForScope(scope);
    }
    connectModule(module) {
        this.modulesByIdentifier.set(module.identifier, module);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.connectContextForScope(scope));
    }
    disconnectModule(module) {
        this.modulesByIdentifier.delete(module.identifier);
        const scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
        scopes.forEach((scope)=>module.disconnectContextForScope(scope));
    }
}
const defaultSchema = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: (identifier)=>`data-${identifier}-target`,
    outletAttributeForScope: (identifier, outlet)=>`data-${identifier}-${outlet}-outlet`,
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End"
    }, objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map((c)=>[
            c,
            c
        ]))), objectFromEntries("0123456789".split("").map((n)=>[
            n,
            n
        ])))
};
function objectFromEntries(array) {
    return array.reduce((memo, [k, v])=>Object.assign(Object.assign({}, memo), {
            [k]: v
        }), {});
}
class Application {
    constructor(element = document.documentElement, schema = defaultSchema){
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = (identifier, functionName, detail = {})=>{
            if (this.debug) this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new Dispatcher(this);
        this.router = new Router(this);
        this.actionDescriptorFilters = Object.assign({}, defaultActionDescriptorFilters);
    }
    static start(element, schema) {
        const application = new this(element, schema);
        application.start();
        return application;
    }
    async start() {
        await domReady();
        this.logDebugActivity("application", "starting");
        this.dispatcher.start();
        this.router.start();
        this.logDebugActivity("application", "start");
    }
    stop() {
        this.logDebugActivity("application", "stopping");
        this.dispatcher.stop();
        this.router.stop();
        this.logDebugActivity("application", "stop");
    }
    register(identifier, controllerConstructor) {
        this.load({
            identifier: identifier,
            controllerConstructor: controllerConstructor
        });
    }
    registerActionOption(name, filter) {
        this.actionDescriptorFilters[name] = filter;
    }
    load(head, ...rest) {
        const definitions = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        definitions.forEach((definition)=>{
            if (definition.controllerConstructor.shouldLoad) this.router.loadDefinition(definition);
        });
    }
    unload(head, ...rest) {
        const identifiers = Array.isArray(head) ? head : [
            head,
            ...rest
        ];
        identifiers.forEach((identifier)=>this.router.unloadIdentifier(identifier));
    }
    get controllers() {
        return this.router.contexts.map((context)=>context.controller);
    }
    getControllerForElementAndIdentifier(element, identifier) {
        const context = this.router.getContextForElementAndIdentifier(element, identifier);
        return context ? context.controller : null;
    }
    handleError(error, message, detail) {
        var _a;
        this.logger.error(`%s\n\n%o\n\n%o`, message, error, detail);
        (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
    }
    logFormattedMessage(identifier, functionName, detail = {}) {
        detail = Object.assign({
            application: this
        }, detail);
        this.logger.groupCollapsed(`${identifier} #${functionName}`);
        this.logger.log("details:", Object.assign({}, detail));
        this.logger.groupEnd();
    }
}
function domReady() {
    return new Promise((resolve)=>{
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", ()=>resolve());
        else resolve();
    });
}
function ClassPropertiesBlessing(constructor) {
    const classes = readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce((properties, classDefinition)=>{
        return Object.assign(properties, propertiesForClassDefinition(classDefinition));
    }, {});
}
function propertiesForClassDefinition(key) {
    return {
        [`${key}Class`]: {
            get () {
                const { classes  } = this;
                if (classes.has(key)) return classes.get(key);
                else {
                    const attribute = classes.getAttributeName(key);
                    throw new Error(`Missing attribute "${attribute}"`);
                }
            }
        },
        [`${key}Classes`]: {
            get () {
                return this.classes.getAll(key);
            }
        },
        [`has${capitalize(key)}Class`]: {
            get () {
                return this.classes.has(key);
            }
        }
    };
}
function OutletPropertiesBlessing(constructor) {
    const outlets = readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce((properties, outletDefinition)=>{
        return Object.assign(properties, propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function propertiesForOutletDefinition(name) {
    const camelizedName = namespaceCamelize(name);
    return {
        [`${camelizedName}Outlet`]: {
            get () {
                const outlet = this.outlets.find(name);
                if (outlet) {
                    const outletController = this.application.getControllerForElementAndIdentifier(outlet, name);
                    if (outletController) return outletController;
                    else throw new Error(`Missing "data-controller=${name}" attribute on outlet element for "${this.identifier}" controller`);
                }
                throw new Error(`Missing outlet element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${camelizedName}Outlets`]: {
            get () {
                const outlets = this.outlets.findAll(name);
                if (outlets.length > 0) return outlets.map((outlet)=>{
                    const controller = this.application.getControllerForElementAndIdentifier(outlet, name);
                    if (controller) return controller;
                    else console.warn(`The provided outlet element is missing the outlet controller "${name}" for "${this.identifier}"`, outlet);
                }).filter((controller)=>controller);
                return [];
            }
        },
        [`${camelizedName}OutletElement`]: {
            get () {
                const outlet = this.outlets.find(name);
                if (outlet) return outlet;
                else throw new Error(`Missing outlet element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${camelizedName}OutletElements`]: {
            get () {
                return this.outlets.findAll(name);
            }
        },
        [`has${capitalize(camelizedName)}Outlet`]: {
            get () {
                return this.outlets.has(name);
            }
        }
    };
}
function TargetPropertiesBlessing(constructor) {
    const targets = readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce((properties, targetDefinition)=>{
        return Object.assign(properties, propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function propertiesForTargetDefinition(name) {
    return {
        [`${name}Target`]: {
            get () {
                const target = this.targets.find(name);
                if (target) return target;
                else throw new Error(`Missing target element "${name}" for "${this.identifier}" controller`);
            }
        },
        [`${name}Targets`]: {
            get () {
                return this.targets.findAll(name);
            }
        },
        [`has${capitalize(name)}Target`]: {
            get () {
                return this.targets.has(name);
            }
        }
    };
}
function ValuePropertiesBlessing(constructor) {
    const valueDefinitionPairs = readInheritableStaticObjectPairs(constructor, "values");
    const propertyDescriptorMap = {
        valueDescriptorMap: {
            get () {
                return valueDefinitionPairs.reduce((result, valueDefinitionPair)=>{
                    const valueDescriptor = parseValueDefinitionPair(valueDefinitionPair, this.identifier);
                    const attributeName = this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, {
                        [attributeName]: valueDescriptor
                    });
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce((properties, valueDefinitionPair)=>{
        return Object.assign(properties, propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    const definition = parseValueDefinitionPair(valueDefinitionPair, controller);
    const { key , name , reader: read , writer: write  } = definition;
    return {
        [name]: {
            get () {
                const value = this.data.get(key);
                if (value !== null) return read(value);
                else return definition.defaultValue;
            },
            set (value) {
                if (value === undefined) this.data.delete(key);
                else this.data.set(key, write(value));
            }
        },
        [`has${capitalize(name)}`]: {
            get () {
                return this.data.has(key) || definition.hasCustomDefaultValue;
            }
        }
    };
}
function parseValueDefinitionPair([token, typeDefinition], controller) {
    return valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function parseValueTypeObject(payload) {
    const typeFromObject = parseValueTypeConstant(payload.typeObject.type);
    if (!typeFromObject) return;
    const defaultValueType = parseValueTypeDefault(payload.typeObject.default);
    if (typeFromObject !== defaultValueType) {
        const propertyPath = payload.controller ? `${payload.controller}.${payload.token}` : payload.token;
        throw new Error(`The specified default value for the Stimulus Value "${propertyPath}" must match the defined type "${typeFromObject}". The provided default value of "${payload.typeObject.default}" is of type "${defaultValueType}".`);
    }
    return typeFromObject;
}
function parseValueTypeDefinition(payload) {
    const typeFromObject = parseValueTypeObject({
        controller: payload.controller,
        token: payload.token,
        typeObject: payload.typeDefinition
    });
    const typeFromDefaultValue = parseValueTypeDefault(payload.typeDefinition);
    const typeFromConstant = parseValueTypeConstant(payload.typeDefinition);
    const type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    const propertyPath = payload.controller ? `${payload.controller}.${payload.typeDefinition}` : payload.token;
    throw new Error(`Unknown value type "${propertyPath}" for "${payload.token}" value`);
}
function defaultValueForDefinition(typeDefinition) {
    const constant = parseValueTypeConstant(typeDefinition);
    if (constant) return defaultValuesByType[constant];
    const defaultValue = typeDefinition.default;
    if (defaultValue !== undefined) return defaultValue;
    return typeDefinition;
}
function valueDescriptorForTokenAndTypeDefinition(payload) {
    const key = `${dasherize(payload.token)}-value`;
    const type = parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: camelize(key),
        get defaultValue () {
            return defaultValueForDefinition(payload.typeDefinition);
        },
        get hasCustomDefaultValue () {
            return parseValueTypeDefault(payload.typeDefinition) !== undefined;
        },
        reader: readers[type],
        writer: writers[type] || writers.default
    };
}
const defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
const readers = {
    array (value) {
        const array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError(`expected value of type "array" but instead got value "${value}" of type "${parseValueTypeDefault(array)}"`);
        return array;
    },
    boolean (value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number (value) {
        return Number(value);
    },
    object (value) {
        const object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError(`expected value of type "object" but instead got value "${value}" of type "${parseValueTypeDefault(object)}"`);
        return object;
    },
    string (value) {
        return value;
    }
};
const writers = {
    default: writeString,
    array: writeJSON,
    object: writeJSON
};
function writeJSON(value) {
    return JSON.stringify(value);
}
function writeString(value) {
    return `${value}`;
}
class Controller {
    constructor(context){
        this.context = context;
    }
    static get shouldLoad() {
        return true;
    }
    static afterLoad(_identifier, _application) {
        return;
    }
    get application() {
        return this.context.application;
    }
    get scope() {
        return this.context.scope;
    }
    get element() {
        return this.scope.element;
    }
    get identifier() {
        return this.scope.identifier;
    }
    get targets() {
        return this.scope.targets;
    }
    get outlets() {
        return this.scope.outlets;
    }
    get classes() {
        return this.scope.classes;
    }
    get data() {
        return this.scope.data;
    }
    initialize() {}
    connect() {}
    disconnect() {}
    dispatch(eventName, { target =this.element , detail ={} , prefix =this.identifier , bubbles =true , cancelable =true  } = {}) {
        const type = prefix ? `${prefix}:${eventName}` : eventName;
        const event = new CustomEvent(type, {
            detail: detail,
            bubbles: bubbles,
            cancelable: cancelable
        });
        target.dispatchEvent(event);
        return event;
    }
}
Controller.blessings = [
    ClassPropertiesBlessing,
    TargetPropertiesBlessing,
    ValuePropertiesBlessing,
    OutletPropertiesBlessing
];
Controller.targets = [];
Controller.outlets = [];
Controller.values = {};

});


var $2AfVR = parcelRequire("2AfVR");

var $2AfVR = parcelRequire("2AfVR");
var $6b550d0fb366c5e9$exports = {};
var $6b550d0fb366c5e9$var$e, $6b550d0fb366c5e9$var$t;
$6b550d0fb366c5e9$var$e = $6b550d0fb366c5e9$exports, $6b550d0fb366c5e9$var$t = function() {
    "use strict";
    function e(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function t(t) {
        for(var n = 1; n < arguments.length; n++){
            var i = null != arguments[n] ? arguments[n] : {};
            n % 2 ? e(Object(i), !0).forEach(function(e) {
                r(t, e, i[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : e(Object(i)).forEach(function(e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
            });
        }
        return t;
    }
    function n(e) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, n(e);
    }
    function r(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function i(e) {
        return function(e) {
            if (Array.isArray(e)) return s(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || o(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0;
        }
    }
    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
        return r;
    }
    var u = function(e) {
        return "string" == typeof e ? document.querySelector(e) : e();
    }, a = function(e, t) {
        var n = "string" == typeof e ? document.createElement(e) : e;
        for(var r in t){
            var i = t[r];
            if ("inside" === r) i.append(n);
            else if ("dest" === r) u(i[0]).insertAdjacentElement(i[1], n);
            else if ("around" === r) {
                var o = i;
                o.parentNode.insertBefore(n, o), n.append(o), null != o.getAttribute("autofocus") && o.focus();
            } else r in n ? n[r] = i : n.setAttribute(r, i);
        }
        return n;
    }, c = function(e, t) {
        return e = String(e).toLowerCase(), t ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").normalize("NFC") : e;
    }, l = function(e, n) {
        return a("mark", t({
            innerHTML: e
        }, "string" == typeof n && {
            class: n
        })).outerHTML;
    }, f = function(e, t) {
        t.input.dispatchEvent(new CustomEvent(e, {
            bubbles: !0,
            detail: t.feedback,
            cancelable: !0
        }));
    }, p = function(e, t, n) {
        var r = n || {}, i = r.mode, o = r.diacritics, s = r.highlight, u = c(t, o);
        if (t = String(t), e = c(e, o), "loose" === i) {
            var a = (e = e.replace(/ /g, "")).length, f = 0, p = Array.from(t).map(function(t, n) {
                return f < a && u[n] === e[f] && (t = s ? l(t, s) : t, f++), t;
            }).join("");
            if (f === a) return p;
        } else {
            var d = u.indexOf(e);
            if (~d) return e = t.substring(d, d + e.length), d = s ? t.replace(e, l(e, s)) : t;
        }
    }, d = function(e, t) {
        return new Promise(function(n, r) {
            var i;
            return (i = e.data).cache && i.store ? n() : new Promise(function(e, n) {
                return "function" == typeof i.src ? i.src(t).then(e, n) : e(i.src);
            }).then(function(t) {
                try {
                    return e.feedback = i.store = t, f("response", e), n();
                } catch (e) {
                    return r(e);
                }
            }, r);
        });
    }, h = function(e, t) {
        var n = t.data, r = t.searchEngine, i = [];
        n.store.forEach(function(s, u) {
            var a = function(n) {
                var o = n ? s[n] : s, u = "function" == typeof r ? r(e, o) : p(e, o, {
                    mode: r,
                    diacritics: t.diacritics,
                    highlight: t.resultItem.highlight
                });
                if (u) {
                    var a = {
                        match: u,
                        value: s
                    };
                    n && (a.key = n), i.push(a);
                }
            };
            if (n.keys) {
                var c, l = function(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = o(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var s, u = !0, a = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return u = e.done, e;
                        },
                        e: function(e) {
                            a = !0, s = e;
                        },
                        f: function() {
                            try {
                                u || null == n.return || n.return();
                            } finally{
                                if (a) throw s;
                            }
                        }
                    };
                }(n.keys);
                try {
                    for(l.s(); !(c = l.n()).done;)a(c.value);
                } catch (e) {
                    l.e(e);
                } finally{
                    l.f();
                }
            } else a();
        }), n.filter && (i = n.filter(i));
        var s = i.slice(0, t.resultsList.maxResults);
        t.feedback = {
            query: e,
            matches: i,
            results: s
        }, f("results", t);
    }, m = "aria-expanded", b = "aria-activedescendant", y = "aria-selected", v = function(e, n) {
        e.feedback.selection = t({
            index: n
        }, e.feedback.results[n]);
    }, g = function(e) {
        e.isOpen || ((e.wrapper || e.input).setAttribute(m, !0), e.list.removeAttribute("hidden"), e.isOpen = !0, f("open", e));
    }, w = function(e) {
        e.isOpen && ((e.wrapper || e.input).setAttribute(m, !1), e.input.setAttribute(b, ""), e.list.setAttribute("hidden", ""), e.isOpen = !1, f("close", e));
    }, O = function(e, t) {
        var n = t.resultItem, r = t.list.getElementsByTagName(n.tag), o = !!n.selected && n.selected.split(" ");
        if (t.isOpen && r.length) {
            var s, u, a = t.cursor;
            e >= r.length && (e = 0), e < 0 && (e = r.length - 1), t.cursor = e, a > -1 && (r[a].removeAttribute(y), o && (u = r[a].classList).remove.apply(u, i(o))), r[e].setAttribute(y, !0), o && (s = r[e].classList).add.apply(s, i(o)), t.input.setAttribute(b, r[t.cursor].id), t.list.scrollTop = r[e].offsetTop - t.list.clientHeight + r[e].clientHeight + 5, t.feedback.cursor = t.cursor, v(t, e), f("navigate", t);
        }
    }, A = function(e) {
        O(e.cursor + 1, e);
    }, k = function(e) {
        O(e.cursor - 1, e);
    }, L = function(e, t, n) {
        (n = n >= 0 ? n : e.cursor) < 0 || (e.feedback.event = t, v(e, n), f("selection", e), w(e));
    };
    function j(e, n) {
        var r = this;
        return new Promise(function(i, o) {
            var s, u;
            return s = n || ((u = e.input) instanceof HTMLInputElement || u instanceof HTMLTextAreaElement ? u.value : u.innerHTML), function(e, t, n) {
                return t ? t(e) : e.length >= n;
            }(s = e.query ? e.query(s) : s, e.trigger, e.threshold) ? d(e, s).then(function(n) {
                try {
                    return e.feedback instanceof Error ? i() : (h(s, e), e.resultsList && function(e) {
                        var n = e.resultsList, r = e.list, i = e.resultItem, o = e.feedback, s = o.matches, u = o.results;
                        if (e.cursor = -1, r.innerHTML = "", s.length || n.noResults) {
                            var c = new DocumentFragment;
                            u.forEach(function(e, n) {
                                var r = a(i.tag, t({
                                    id: "".concat(i.id, "_").concat(n),
                                    role: "option",
                                    innerHTML: e.match,
                                    inside: c
                                }, i.class && {
                                    class: i.class
                                }));
                                i.element && i.element(r, e);
                            }), r.append(c), n.element && n.element(r, o), g(e);
                        } else w(e);
                    }(e), c.call(r));
                } catch (e) {
                    return o(e);
                }
            }, o) : (w(e), c.call(r));
            function c() {
                return i();
            }
        });
    }
    var S = function(e, t) {
        for(var n in e)for(var r in e[n])t(n, r);
    }, T = function(e) {
        var n, r, i, o = e.events, s = (n = function() {
            return j(e);
        }, r = e.debounce, function() {
            clearTimeout(i), i = setTimeout(function() {
                return n();
            }, r);
        }), u = e.events = t({
            input: t({}, o && o.input)
        }, e.resultsList && {
            list: o ? t({}, o.list) : {}
        }), a = {
            input: {
                input: function() {
                    s();
                },
                keydown: function(t) {
                    !function(e, t) {
                        switch(e.keyCode){
                            case 40:
                            case 38:
                                e.preventDefault(), 40 === e.keyCode ? A(t) : k(t);
                                break;
                            case 13:
                                t.submit || e.preventDefault(), t.cursor >= 0 && L(t, e);
                                break;
                            case 9:
                                t.resultsList.tabSelect && t.cursor >= 0 && L(t, e);
                                break;
                            case 27:
                                t.input.value = "", w(t);
                        }
                    }(t, e);
                },
                blur: function() {
                    w(e);
                }
            },
            list: {
                mousedown: function(e) {
                    e.preventDefault();
                },
                click: function(t) {
                    !function(e, t) {
                        var n = t.resultItem.tag.toUpperCase(), r = Array.from(t.list.querySelectorAll(n)), i = e.target.closest(n);
                        i && i.nodeName === n && L(t, e, r.indexOf(i));
                    }(t, e);
                }
            }
        };
        S(a, function(t, n) {
            (e.resultsList || "input" === n) && (u[t][n] || (u[t][n] = a[t][n]));
        }), S(u, function(t, n) {
            e[t].addEventListener(n, u[t][n]);
        });
    };
    function E(e) {
        var n = this;
        return new Promise(function(r, i) {
            var o, s, u;
            if (o = e.placeHolder, u = {
                role: "combobox",
                "aria-owns": (s = e.resultsList).id,
                "aria-haspopup": !0,
                "aria-expanded": !1
            }, a(e.input, t(t({
                "aria-controls": s.id,
                "aria-autocomplete": "both"
            }, o && {
                placeholder: o
            }), !e.wrapper && t({}, u))), e.wrapper && (e.wrapper = a("div", t({
                around: e.input,
                class: e.name + "_wrapper"
            }, u))), s && (e.list = a(s.tag, t({
                dest: [
                    s.destination,
                    s.position
                ],
                id: s.id,
                role: "listbox",
                hidden: "hidden"
            }, s.class && {
                class: s.class
            }))), T(e), e.data.cache) return d(e).then(function(e) {
                try {
                    return c.call(n);
                } catch (e) {
                    return i(e);
                }
            }, i);
            function c() {
                return f("init", e), r();
            }
            return c.call(n);
        });
    }
    function x(e) {
        var t = e.prototype;
        t.init = function() {
            E(this);
        }, t.start = function(e) {
            j(this, e);
        }, t.unInit = function() {
            if (this.wrapper) {
                var e = this.wrapper.parentNode;
                e.insertBefore(this.input, this.wrapper), e.removeChild(this.wrapper);
            }
            var t;
            S((t = this).events, function(e, n) {
                t[e].removeEventListener(n, t.events[e][n]);
            });
        }, t.open = function() {
            g(this);
        }, t.close = function() {
            w(this);
        }, t.goTo = function(e) {
            O(e, this);
        }, t.next = function() {
            A(this);
        }, t.previous = function() {
            k(this);
        }, t.select = function(e) {
            L(this, null, e);
        }, t.search = function(e, t, n) {
            return p(e, t, n);
        };
    }
    return function e(t) {
        this.options = t, this.id = e.instances = (e.instances || 0) + 1, this.name = "autoComplete", this.wrapper = 1, this.threshold = 1, this.debounce = 0, this.resultsList = {
            position: "afterend",
            tag: "ul",
            maxResults: 5
        }, this.resultItem = {
            tag: "li"
        }, function(e) {
            var t = e.name, r = e.options, i = e.resultsList, o = e.resultItem;
            for(var s in r)if ("object" === n(r[s])) for(var a in e[s] || (e[s] = {}), r[s])e[s][a] = r[s][a];
            else e[s] = r[s];
            e.selector = e.selector || "#" + t, i.destination = i.destination || e.selector, i.id = i.id || t + "_list_" + e.id, o.id = o.id || t + "_result", e.input = u(e.selector);
        }(this), x.call(this, e), E(this);
    };
}, $6b550d0fb366c5e9$exports = $6b550d0fb366c5e9$var$t();


class $b932326b47d86c38$var$AutoCompleteController extends (0, $2AfVR.Controller) {
    static values = {
        lookup: Array
    };
    initialize() {
        const autoCompleteJS = new (0, (/*@__PURE__*/$parcel$interopDefault($6b550d0fb366c5e9$exports)))({
            placeHolder: "Votre entreprise",
            data: {
                src: this.lookupValue
            },
            selector: `#${this.element.getAttribute("id")}`,
            resultItem: {
                highlight: true
            },
            events: {
                input: {
                    selection: (event)=>{
                        const selection = event.detail.selection.value;
                        autoCompleteJS.input.value = selection;
                    }
                }
            }
        });
    }
}
var $b932326b47d86c38$export$2e2bcd8739ae039 = $b932326b47d86c38$var$AutoCompleteController;



var $2AfVR = parcelRequire("2AfVR");
var $428fcb2015744f49$exports = {};
(function(global, factory) {
    $428fcb2015744f49$exports = factory();
})($428fcb2015744f49$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});


async function $c527cb14ba93a508$export$2e2bcd8739ae039(url = "", data = {}) {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("csrftoken")
        },
        body: JSON.stringify(data)
    });
    return response.json();
}



async function $23bd0191e824317d$export$2e2bcd8739ae039(url = "", data = {}) {
    const response = await fetch(url, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("csrftoken")
        },
        body: JSON.stringify(data)
    });
    return response.json();
}



async function $eb7bc91e32d43885$export$2e2bcd8739ae039(url = "") {
    const response = await fetch(url, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("csrftoken")
        }
    });
    return response;
}


class $5c1e250f0aecced4$var$BasketController extends (0, $2AfVR.Controller) {
    static targets = [
        "amount",
        "nbItems",
        "details",
        "detailsLines",
        "totalOrderAmount",
        "loginForm",
        "registerForm",
        "shippingAmount",
        "totalAmount",
        "paymentForm",
        "voucherBlock",
        "offerBlock",
        "voucherForm",
        "edenredChoice",
        "edenredChoiceLabel"
    ];
    _updateDetails(jsonData) {
        let html = "<ul>";
        jsonData.forEach(function(line) {
            html += `<li class="p-2 grid grid-cols-5 gap-4">
    <div>
        <img src="${line["product"]["images"][0]["original"]}">
    </div>
    <div class="col-span-3">
        ${line["product"]["title"]}<br>
        <div data-controller="product"
         data-product-initial-quantity="${line["quantity"]}"
         data-product-id="${line["product"]["id"]}" class="flex">
            
            <div class="flex bg-green-pure border-2 border-black justify-between font-bold">
                    <button class="px-1 py-2"
                            data-action="product#removeFromCart"
                            data-product-id="${line["product"]["id"]}">-</button>
                    <div class="px-1 py-2" data-product-target="quantity">${line["quantity"]}</div>
                    <button class="px-1 py-2"
                            data-action="product#addToCart"
                            data-product-id="${line["product"]["id"]}">+</button>
                </div>
            
            
         </div>
    </div>
    <div>
        ${line["price_incl_tax"]}€
    </div>
    </li><hr>`;
        });
        html += "</ul>";
        this.detailsLinesTarget.innerHTML = html;
    }
    _updateBasketAmounts(jsonData) {
        this.totalOrderAmountTarget.innerText = jsonData["total_incl_tax"] + "€";
        this.shippingAmountTarget.innerText = jsonData["shipping_charges"]["incl_tax"] + "€";
        if (this.hasTotalAmountTarget) this.totalAmountTarget.innerText = jsonData["order_total"]["incl_tax"] + "€";
        this.amountTarget.innerText = jsonData["order_total"]["incl_tax"] + "€";
        this.nbItemsTarget.innerText = jsonData["lines"].length;
    }
    toogleDetails(event) {
        event.preventDefault();
        this.detailsTarget.classList.toggle("hidden");
        this.detailsTarget.classList.toggle("flex");
    }
    toogleLogin(event) {
        event.preventDefault();
        this.loginFormTarget.classList.toggle("hidden");
        this.loginFormTarget.classList.toggle("flex");
    }
    toogleRegister(event) {
        event.preventDefault();
        this.registerFormTarget.classList.toggle("hidden");
        this.registerFormTarget.classList.toggle("flex");
    }
    tooglePaymentForm(shouldShowForm) {
        if (!this.hasPaymentFormTarget) return;
        if (shouldShowForm) this.paymentFormTarget.classList.remove("hidden");
        else this.paymentFormTarget.classList.add("hidden");
    }
    _displayPaymentMethod(totalAmount) {
        if (totalAmount > 25.0) {
            this.edenredChoiceTarget.disabled = true;
            this.edenredChoiceLabelTarget.classList.add("text-gray-darker");
        } else {
            this.edenredChoiceTarget.disabled = false;
            this.edenredChoiceLabelTarget.classList.remove("text-gray-darker");
        }
    }
    _syncAllPickers(jsonData) {
        jsonData.forEach(function(line) {
            const event = new CustomEvent("setProductQuantity", {
                detail: {
                    id: line["product"]["id"],
                    quantity: line["quantity"],
                    previousQuantity: line["quantity"]
                }
            });
            document.dispatchEvent(event);
        });
    }
    _get_offer_text(offerNames) {
        let offers = "";
        offerNames.forEach((offer)=>{
            let name = "";
            if (offer === "Full meal offer") name = "Formule entr\xe9e/plat/dessert (-1€) ✅";
            if (offer === "Meal offer") name = "Formule plat + entr\xe9e ou dessert (-0.5€) ✅";
            offers += name;
        });
        return offers;
    }
    _showDiscounts(json) {
        var voucherNames = json["voucher_discounts"].map(function(item) {
            return item.voucher.code;
        });
        if (voucherNames.length > 0) {
            this.voucherBlockTarget.classList.remove("hidden");
            this.voucherBlockTarget.querySelector("#message").innerText = "Code promo : " + voucherNames.join(", ");
            this.voucherFormTarget.classList.add("hidden");
        } else {
            this.voucherBlockTarget.classList.add("hidden");
            this.voucherFormTarget.classList.remove("hidden");
        }
        var offerNames = json["offer_discounts"].map(function(item) {
            return item.name;
        });
        if (offerNames.length > 0) {
            this.offerBlockTarget.classList.remove("hidden");
            this.offerBlockTarget.innerText = this._get_offer_text(offerNames);
        } else this.offerBlockTarget.classList.add("hidden");
    }
    _updatePanel(json) {
        this._updateDetails(json["lines"]);
        this._updateBasketAmounts(json);
        this.tooglePaymentForm(Boolean(json["lines"].length));
        this._displayPaymentMethod(json["order_total"]["incl_tax"]);
        this._syncAllPickers(json["lines"]);
        this._showDiscounts(json);
    }
    _addToCart(productId) {
        const data = {
            url: `${this.data.get("productApiUrl")}${productId}/`,
            quantity: 1
        };
        (0, $c527cb14ba93a508$export$2e2bcd8739ae039)(this.data.get("addToCartApi"), data).then((json)=>{
            if (json["reason"]) {
                document.dispatchEvent(new CustomEvent("displayMessage", {
                    detail: json["reason"]
                }));
                this._fetchBasketAndUpdatePanel();
            } else this._updatePanel(json);
        });
    }
    _fetchBasketAndUpdatePanel() {
        fetch(this.data.get("apiUrl"), {
            method: "GET"
        }).then((response)=>response.json()).then((json)=>{
            this._updatePanel(json);
        });
    }
    _removeFromCart(productId, quantity) {
        const basketApiUrl = this.data.get("apiUrl");
        fetch(basketApiUrl, {
            method: "GET"
        }).then((response)=>response.json()).then((json)=>{
            const lineForProduct = json["lines"].find((obj)=>{
                return obj.product.id == productId;
            });
            if (quantity == 0) (0, $eb7bc91e32d43885$export$2e2bcd8739ae039)(lineForProduct.url).then(()=>{
                this._fetchBasketAndUpdatePanel();
            });
            else (0, $23bd0191e824317d$export$2e2bcd8739ae039)(lineForProduct.url, {
                quantity: quantity
            }).then(()=>{
                this._fetchBasketAndUpdatePanel();
            });
        });
    }
    connect() {
        this._fetchBasketAndUpdatePanel();
        document.addEventListener("setProductQuantity", (event)=>{
            if (event.detail.previousQuantity < event.detail.quantity) this._addToCart(event.detail.id);
            else if (event.detail.previousQuantity > event.detail.quantity) this._removeFromCart(event.detail.id, event.detail.quantity);
        });
        document.addEventListener("voucherAdded", ()=>{
            this._fetchBasketAndUpdatePanel();
        });
    }
}
var $5c1e250f0aecced4$export$2e2bcd8739ae039 = $5c1e250f0aecced4$var$BasketController;




var $2AfVR = parcelRequire("2AfVR");
class $5134bda4cc9eef48$var$CourrierTourController extends (0, $2AfVR.Controller) {
    markAsShipped(event) {
        fetch(event.currentTarget.dataset.url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("csrftoken")
            }
        });
        const target = event.target.parentElement.parentElement.querySelector(".swipe-item");
        window.requestAnimationFrame(()=>{
            target.style.transition = "transform .2s ease-in";
            target.style.transform = null;
        });
    }
}
var $5134bda4cc9eef48$export$2e2bcd8739ae039 = $5134bda4cc9eef48$var$CourrierTourController;




var $2AfVR = parcelRequire("2AfVR");
class $ea702e2c2ddb4b36$var$CourrierPickupTourController extends (0, $2AfVR.Controller) {
    markAsShipped(event) {
        fetch(event.currentTarget.dataset.url, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("csrftoken")
            }
        });
        const target = event.target.parentElement.parentElement.querySelector(".swipe-item");
        window.requestAnimationFrame(()=>{
            target.style.transition = "transform .2s ease-in";
            target.style.transform = null;
        });
    }
}
var $ea702e2c2ddb4b36$export$2e2bcd8739ae039 = $ea702e2c2ddb4b36$var$CourrierPickupTourController;



var $2AfVR = parcelRequire("2AfVR");
class $f8a14f20f89bf263$var$MessageController extends (0, $2AfVR.Controller) {
    static targets = [
        "messageText"
    ];
    connect() {
        document.addEventListener("displayMessage", (event)=>{
            this.messageTextTarget.innerHTML = event.detail;
            this.messageTextTarget.parentNode.classList.remove("hidden");
        });
    }
}
var $f8a14f20f89bf263$export$2e2bcd8739ae039 = $f8a14f20f89bf263$var$MessageController;



var $2AfVR = parcelRequire("2AfVR");

class $a2acfda34e5abb9c$var$PaymentController extends (0, $2AfVR.Controller) {
    static targets = [];
    _disableButton(btn) {
        btn.innerText = "Paiement en cours...";
        btn.disabled = true;
    }
    _displayMessage(message) {
        const event = new CustomEvent("displayMessage", {
            detail: message
        });
        document.dispatchEvent(event);
    }
    async startPayment(event) {
        const btn = event.currentTarget;
        event.preventDefault();
        this._disableButton(btn);
        const response = await fetch(this.data.get("actionUrl"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($428fcb2015744f49$exports))).get("csrftoken"),
                "X-RequestedWith": "JavaScript"
            },
            body: new FormData(btn.form)
        });
        if (!response.ok) this._displayMessage("Une erreur est survenue, veuillez r\xe9essayer");
        let jsonData = null;
        try {
            jsonData = await response.json();
        } catch (e) {
            location.reload();
            return;
        }
        if (jsonData.code && jsonData.code === "PAYMENT IN PROGRESS") this._displayMessage(`Un payement est déjà en cours : <a href="${jsonData.url}">reprendre le paiement</a>`);
        else setTimeout(()=>{
            window.open(jsonData.redirect_url, jsonData.target);
        });
    }
}
var $a2acfda34e5abb9c$export$2e2bcd8739ae039 = $a2acfda34e5abb9c$var$PaymentController;



var $2AfVR = parcelRequire("2AfVR");
class $d6b2f310850c2f46$var$ProductController extends (0, $2AfVR.Controller) {
    static targets = [
        "quantityPicker",
        "quantityAddPicker",
        "addToCart",
        "quantity"
    ];
    addToCart() {
        const previousQuantity = parseInt(this.quantity);
        this.quantity = parseInt(this.quantity) + 1;
        const event = new CustomEvent("setProductQuantity", {
            detail: {
                id: this.data.get("id"),
                quantity: this.quantity,
                previousQuantity: previousQuantity
            }
        });
        document.dispatchEvent(event);
        this._setQuantityDisplayTo(this.quantity);
    }
    removeFromCart() {
        const previousQuantity = parseInt(this.quantity);
        this.quantity = parseInt(this.quantity) - 1;
        const event = new CustomEvent("setProductQuantity", {
            detail: {
                id: this.data.get("id"),
                quantity: this.quantity,
                previousQuantity: previousQuantity
            }
        });
        document.dispatchEvent(event);
        this._setQuantityDisplayTo(this.quantity);
    }
    _setQuantityDisplayTo(quantity) {
        if (quantity == 0) {
            this.quantityPickerTarget.classList.add("hidden");
            this.addToCartTarget.classList.remove("hidden");
        } else {
            if (this.hasQuantityPickerTarget) this.quantityPickerTarget.classList.remove("hidden");
            if (this.hasAddToCartTarget) this.addToCartTarget.classList.add("hidden");
            if (this.hasQuantityTarget) this.quantityTarget.innerHTML = this.quantity;
        }
    }
    openSidebar(event) {
        event.preventDefault();
        const eventToSend = new CustomEvent("openSidebar", {
            detail: {
                id: this.data.get("id")
            }
        });
        document.dispatchEvent(eventToSend);
    }
    connect() {
        this.quantity = this.data.get("initialQuantity");
        document.addEventListener("setProductQuantity", (event)=>{
            if (event.detail.id == this.data.get("id")) {
                this.quantity = event.detail.quantity;
                this._setQuantityDisplayTo(this.quantity);
            }
        });
    }
}
var $d6b2f310850c2f46$export$2e2bcd8739ae039 = $d6b2f310850c2f46$var$ProductController;



var $2AfVR = parcelRequire("2AfVR");
class $9cca1a06a8a90da9$var$SidebarController extends (0, $2AfVR.Controller) {
    static targets = [];
    connect() {
        document.addEventListener("openSidebar", (event)=>{
            document.querySelectorAll(".sidebar-left").forEach((el)=>el.classList.add("hidden"));
            document.querySelectorAll(".sidebar-left").forEach((el)=>el.classList.remove("flex"));
            const sidebar = document.getElementById(`sidebar-${event.detail.id}`);
            sidebar.classList.toggle("hidden");
            sidebar.classList.toggle("flex");
        });
    }
    closeSidebar(event) {
        event.preventDefault();
        const sidebar = event.currentTarget.parentNode.parentNode.parentNode;
        sidebar.classList.toggle("hidden");
        sidebar.classList.toggle("flex");
    }
}
var $9cca1a06a8a90da9$export$2e2bcd8739ae039 = $9cca1a06a8a90da9$var$SidebarController;



var $2AfVR = parcelRequire("2AfVR");

class $d30bacd09465fe91$var$VoucherController extends (0, $2AfVR.Controller) {
    static targets = [
        "voucherCode",
        "voucherCodeError"
    ];
    submitVoucher() {
        this.voucherCodeErrorTarget.innerText = "";
        const data = {
            vouchercode: this.voucherCodeTarget.value
        };
        const errorBlock = this.voucherCodeErrorTarget;
        (0, $c527cb14ba93a508$export$2e2bcd8739ae039)(this.data.get("addVoucherToCartApi"), data).then((json)=>{
            if (json["reason"] && json["reason"] === "Votre panier n'est pas admissible \xe0 un code de r\xe9duction") {
                errorBlock.innerText = "Votre panier ne respecte pas le montant minimum pour ce code promo.";
                return;
            }
            if (json["non_field_errors"]) {
                if (json["non_field_errors"].includes("Voucher code unknown")) errorBlock.innerText = "Ce code promo n'est pas reconnu";
                else if (json["non_field_errors"][0].includes("expir\xe9")) errorBlock.innerText = "Ce code est expir\xe9";
                else console.log("Unknown error");
            } else document.dispatchEvent(new CustomEvent("voucherAdded"));
        });
    }
    removeVoucher() {
        const data = {
            vouchercode: this.voucherCodeTarget.value
        };
        (0, $c527cb14ba93a508$export$2e2bcd8739ae039)(this.data.get("removeVoucherFromCartApi"), data).then((json)=>{
            document.dispatchEvent(new CustomEvent("voucherAdded"));
        });
    }
}
var $d30bacd09465fe91$export$2e2bcd8739ae039 = $d30bacd09465fe91$var$VoucherController;


class $89e29f4803ac025e$var$TinyGesture {
    constructor(element, options){
        this.element = element;
        this.touch1 = null;
        this.touch2 = null;
        this.touchStartX = null;
        this.touchStartY = null;
        this.touchEndX = null;
        this.touchEndY = null;
        this.touchMove1 = null;
        this.touchMove2 = null;
        this.touchMoveX = null;
        this.touchMoveY = null;
        this.velocityX = null;
        this.velocityY = null;
        this.longPressTimer = null;
        this.doubleTapTimer = null;
        this.doubleTapWaiting = false;
        this.thresholdX = 0;
        this.thresholdY = 0;
        this.disregardVelocityThresholdX = 0;
        this.disregardVelocityThresholdY = 0;
        this.swipingHorizontal = false;
        this.swipingVertical = false;
        this.swipingDirection = null;
        this.swipedHorizontal = false;
        this.swipedVertical = false;
        this.originalDistance = null;
        this.newDistance = null;
        this.scale = null;
        this.originalAngle = null;
        this.newAngle = null;
        this.rotation = null;
        this.handlers = {
            panstart: [],
            panmove: [],
            panend: [],
            swipeleft: [],
            swiperight: [],
            swipeup: [],
            swipedown: [],
            tap: [],
            doubletap: [],
            longpress: [],
            pinch: [],
            pinchend: [],
            rotate: [],
            rotateend: []
        };
        this._onTouchStart = this.onTouchStart.bind(this);
        this._onTouchMove = this.onTouchMove.bind(this);
        this._onTouchEnd = this.onTouchEnd.bind(this);
        this.opts = Object.assign({}, $89e29f4803ac025e$var$TinyGesture.defaults, options);
        this.element.addEventListener("touchstart", this._onTouchStart, $89e29f4803ac025e$var$passiveIfSupported);
        this.element.addEventListener("touchmove", this._onTouchMove, $89e29f4803ac025e$var$passiveIfSupported);
        this.element.addEventListener("touchend", this._onTouchEnd, $89e29f4803ac025e$var$passiveIfSupported);
        if (this.opts.mouseSupport && !("ontouchstart" in window)) {
            this.element.addEventListener("mousedown", this._onTouchStart, $89e29f4803ac025e$var$passiveIfSupported);
            document.addEventListener("mousemove", this._onTouchMove, $89e29f4803ac025e$var$passiveIfSupported);
            document.addEventListener("mouseup", this._onTouchEnd, $89e29f4803ac025e$var$passiveIfSupported);
        }
    }
    destroy() {
        var _a, _b;
        this.element.removeEventListener("touchstart", this._onTouchStart);
        this.element.removeEventListener("touchmove", this._onTouchMove);
        this.element.removeEventListener("touchend", this._onTouchEnd);
        this.element.removeEventListener("mousedown", this._onTouchStart);
        document.removeEventListener("mousemove", this._onTouchMove);
        document.removeEventListener("mouseup", this._onTouchEnd);
        clearTimeout((_a = this.longPressTimer) !== null && _a !== void 0 ? _a : undefined);
        clearTimeout((_b = this.doubleTapTimer) !== null && _b !== void 0 ? _b : undefined);
    }
    on(type, fn) {
        if (this.handlers[type]) {
            this.handlers[type].push(fn);
            return {
                type: type,
                fn: fn,
                cancel: ()=>this.off(type, fn)
            };
        }
    }
    off(type, fn) {
        if (this.handlers[type]) {
            const idx = this.handlers[type].indexOf(fn);
            if (idx !== -1) this.handlers[type].splice(idx, 1);
        }
    }
    fire(type, event) {
        for(let i = 0; i < this.handlers[type].length; i++)this.handlers[type][i](event);
    }
    onTouchStart(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
        let didTouch1 = false;
        let didTouch2 = false;
        if (event.type !== "mousedown") {
            if (!this.touch1) {
                this.touch1 = event.changedTouches[0];
                didTouch1 = true;
            }
            if ((didTouch1 && event.changedTouches.length > 1 || !didTouch1) && !this.touch2) {
                this.touch2 = [
                    ...event.changedTouches
                ].find((touch)=>{
                    var _a;
                    return touch.identifier !== ((_a = this.touch1) === null || _a === void 0 ? void 0 : _a.identifier);
                }) || null;
                this.originalDistance = Math.sqrt(Math.pow(((_b = (_a = this.touch2) === null || _a === void 0 ? void 0 : _a.screenX) !== null && _b !== void 0 ? _b : 0) - ((_f = (_d = (_c = this.touchMove1) === null || _c === void 0 ? void 0 : _c.screenX) !== null && _d !== void 0 ? _d : (_e = this.touch1) === null || _e === void 0 ? void 0 : _e.screenX) !== null && _f !== void 0 ? _f : 0), 2) + Math.pow(((_h = (_g = this.touch2) === null || _g === void 0 ? void 0 : _g.screenY) !== null && _h !== void 0 ? _h : 0) - ((_m = (_k = (_j = this.touchMove1) === null || _j === void 0 ? void 0 : _j.screenY) !== null && _k !== void 0 ? _k : (_l = this.touch1) === null || _l === void 0 ? void 0 : _l.screenY) !== null && _m !== void 0 ? _m : 0), 2));
                this.originalAngle = Math.atan2(((_p = (_o = this.touch2) === null || _o === void 0 ? void 0 : _o.screenY) !== null && _p !== void 0 ? _p : 0) - ((_t = (_r = (_q = this.touchMove1) === null || _q === void 0 ? void 0 : _q.screenY) !== null && _r !== void 0 ? _r : (_s = this.touch1) === null || _s === void 0 ? void 0 : _s.screenY) !== null && _t !== void 0 ? _t : 0), ((_v = (_u = this.touch2) === null || _u === void 0 ? void 0 : _u.screenX) !== null && _v !== void 0 ? _v : 0) - ((_z = (_x = (_w = this.touchMove1) === null || _w === void 0 ? void 0 : _w.screenX) !== null && _x !== void 0 ? _x : (_y = this.touch1) === null || _y === void 0 ? void 0 : _y.screenX) !== null && _z !== void 0 ? _z : 0)) / (Math.PI / 180);
                return;
            }
            if (!didTouch1 && !didTouch2) return;
        }
        if (didTouch1 || event.type === "mousedown") {
            this.thresholdX = this.opts.threshold("x", this);
            this.thresholdY = this.opts.threshold("y", this);
            this.disregardVelocityThresholdX = this.opts.disregardVelocityThreshold("x", this);
            this.disregardVelocityThresholdY = this.opts.disregardVelocityThreshold("y", this);
            this.touchStartX = event.type === "mousedown" ? event.screenX : ((_0 = this.touch1) === null || _0 === void 0 ? void 0 : _0.screenX) || 0;
            this.touchStartY = event.type === "mousedown" ? event.screenY : ((_1 = this.touch1) === null || _1 === void 0 ? void 0 : _1.screenY) || 0;
            this.touchMoveX = null;
            this.touchMoveY = null;
            this.touchEndX = null;
            this.touchEndY = null;
            this.swipingDirection = null;
            this.longPressTimer = setTimeout(()=>this.fire("longpress", event), this.opts.longPressTime);
            this.scale = 1;
            this.rotation = 0;
            this.fire("panstart", event);
        }
    }
    onTouchMove(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (event.type === "mousemove" && (!this.touchStartX || this.touchEndX !== null)) return;
        let touch1 = undefined;
        let touch2 = undefined;
        if (event.type !== "mousemove") {
            touch1 = [
                ...event.changedTouches
            ].find((touch)=>{
                var _a;
                return touch.identifier === ((_a = this.touch1) === null || _a === void 0 ? void 0 : _a.identifier);
            });
            this.touchMove1 = touch1 || this.touchMove1;
            touch2 = [
                ...event.changedTouches
            ].find((touch)=>{
                var _a;
                return touch.identifier === ((_a = this.touch2) === null || _a === void 0 ? void 0 : _a.identifier);
            });
            this.touchMove2 = touch2 || this.touchMove2;
        }
        if (event.type === "mousemove" || touch1) {
            const touchMoveX = (event.type === "mousemove" ? event.screenX : (_a = touch1 === null || touch1 === void 0 ? void 0 : touch1.screenX) !== null && _a !== void 0 ? _a : 0) - ((_b = this.touchStartX) !== null && _b !== void 0 ? _b : 0);
            this.velocityX = touchMoveX - ((_c = this.touchMoveX) !== null && _c !== void 0 ? _c : 0);
            this.touchMoveX = touchMoveX;
            const touchMoveY = (event.type === "mousemove" ? event.screenY : (_d = touch1 === null || touch1 === void 0 ? void 0 : touch1.screenY) !== null && _d !== void 0 ? _d : 0) - ((_e = this.touchStartY) !== null && _e !== void 0 ? _e : 0);
            this.velocityY = touchMoveY - ((_f = this.touchMoveY) !== null && _f !== void 0 ? _f : 0);
            this.touchMoveY = touchMoveY;
            const absTouchMoveX = Math.abs(this.touchMoveX);
            const absTouchMoveY = Math.abs(this.touchMoveY);
            this.swipingHorizontal = absTouchMoveX > this.thresholdX;
            this.swipingVertical = absTouchMoveY > this.thresholdY;
            this.swipingDirection = absTouchMoveX > absTouchMoveY ? this.swipingHorizontal ? "horizontal" : "pre-horizontal" : this.swipingVertical ? "vertical" : "pre-vertical";
            if (Math.max(absTouchMoveX, absTouchMoveY) > this.opts.pressThreshold) clearTimeout((_g = this.longPressTimer) !== null && _g !== void 0 ? _g : undefined);
            this.fire("panmove", event);
        }
        if (event.type !== "mousemove" && this.touchMove1 != null && this.touchMove2 != null) {
            this.newDistance = Math.sqrt(Math.pow(this.touchMove2.screenX - this.touchMove1.screenX, 2) + Math.pow(this.touchMove2.screenY - this.touchMove1.screenY, 2));
            this.scale = this.newDistance / ((_h = this.originalDistance) !== null && _h !== void 0 ? _h : 0);
            this.fire("pinch", event);
            this.newAngle = Math.atan2(((_j = this.touchMove2.screenY) !== null && _j !== void 0 ? _j : 0) - ((_k = this.touchMove1.screenY) !== null && _k !== void 0 ? _k : 0), ((_l = this.touchMove2.screenX) !== null && _l !== void 0 ? _l : 0) - ((_m = this.touchMove1.screenX) !== null && _m !== void 0 ? _m : 0)) / (Math.PI / 180);
            this.rotation = this.newAngle - ((_o = this.originalAngle) !== null && _o !== void 0 ? _o : 0);
            this.fire("rotate", event);
        }
    }
    onTouchEnd(event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        let touch1 = undefined;
        if (event.type !== "mouseup") {
            touch1 = [
                ...event.changedTouches
            ].find((touch)=>{
                var _a;
                return touch.identifier === ((_a = this.touch1) === null || _a === void 0 ? void 0 : _a.identifier);
            });
            if (![
                ...event.touches
            ].find((touch)=>{
                var _a;
                return touch.identifier === ((_a = this.touch1) === null || _a === void 0 ? void 0 : _a.identifier);
            })) {
                this.touch1 = null;
                this.touchMove1 = null;
            }
            if (![
                ...event.touches
            ].find((touch)=>{
                var _a;
                return touch.identifier === ((_a = this.touch2) === null || _a === void 0 ? void 0 : _a.identifier);
            })) {
                this.touch2 = null;
                this.touchMove2 = null;
            }
        }
        if (event.type === "mouseup" && (!this.touchStartX || this.touchEndX !== null)) return;
        if (event.type === "mouseup" || touch1) {
            this.touchEndX = event.type === "mouseup" ? event.screenX : (_a = touch1 === null || touch1 === void 0 ? void 0 : touch1.screenX) !== null && _a !== void 0 ? _a : 0;
            this.touchEndY = event.type === "mouseup" ? event.screenY : (_b = touch1 === null || touch1 === void 0 ? void 0 : touch1.screenY) !== null && _b !== void 0 ? _b : 0;
            this.fire("panend", event);
            clearTimeout((_c = this.longPressTimer) !== null && _c !== void 0 ? _c : undefined);
            const x = this.touchEndX - ((_d = this.touchStartX) !== null && _d !== void 0 ? _d : 0);
            const absX = Math.abs(x);
            const y = this.touchEndY - ((_e = this.touchStartY) !== null && _e !== void 0 ? _e : 0);
            const absY = Math.abs(y);
            const distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
            const absDistance = Math.abs(distance);
            const diagonal = absY / absX;
            if (absX > this.thresholdX || absY > this.thresholdY || this.opts.diagonalSwipes && (absDistance > this.thresholdX || absDistance > this.thresholdY)) {
                this.swipedHorizontal = absX > this.thresholdX || this.opts.diagonalSwipes && absDistance > this.thresholdX;
                this.swipedVertical = absY > this.thresholdY || this.opts.diagonalSwipes && absDistance > this.thresholdY;
                if (!this.opts.diagonalSwipes || diagonal < Math.tan((45 - this.opts.diagonalLimit) * Math.PI / 180) || diagonal > Math.tan((45 + this.opts.diagonalLimit) * Math.PI / 180)) {
                    if (absX >= absY) this.swipedVertical = false;
                    if (absY > absX) this.swipedHorizontal = false;
                }
                if (this.swipedHorizontal) {
                    if (x < 0) {
                        if (((_f = this.velocityX) !== null && _f !== void 0 ? _f : 0) < -this.opts.velocityThreshold || distance < -this.disregardVelocityThresholdX) this.fire("swipeleft", event);
                    } else if (((_g = this.velocityX) !== null && _g !== void 0 ? _g : 0) > this.opts.velocityThreshold || distance > this.disregardVelocityThresholdX) this.fire("swiperight", event);
                }
                if (this.swipedVertical) {
                    if (y < 0) {
                        if (((_h = this.velocityY) !== null && _h !== void 0 ? _h : 0) < -this.opts.velocityThreshold || distance < -this.disregardVelocityThresholdY) this.fire("swipeup", event);
                    } else if (((_j = this.velocityY) !== null && _j !== void 0 ? _j : 0) > this.opts.velocityThreshold || distance > this.disregardVelocityThresholdY) this.fire("swipedown", event);
                }
            } else if (absX < this.opts.pressThreshold && absY < this.opts.pressThreshold) {
                if (this.doubleTapWaiting) {
                    this.doubleTapWaiting = false;
                    clearTimeout((_k = this.doubleTapTimer) !== null && _k !== void 0 ? _k : undefined);
                    this.fire("doubletap", event);
                } else {
                    this.doubleTapWaiting = true;
                    this.doubleTapTimer = setTimeout(()=>this.doubleTapWaiting = false, this.opts.doubleTapTime);
                    this.fire("tap", event);
                }
            }
        }
        if (!this.touch1 && !this.touch2) {
            this.fire("pinchend", event);
            this.fire("rotateend", event);
            this.originalDistance = null;
            this.newDistance = null;
            this.scale = null;
            this.originalAngle = null;
            this.newAngle = null;
            this.rotation = null;
        }
    }
}
$89e29f4803ac025e$var$TinyGesture.defaults = {
    threshold: (type, _self)=>Math.max(25, Math.floor(0.15 * (type === "x" ? window.innerWidth || document.body.clientWidth : window.innerHeight || document.body.clientHeight))),
    velocityThreshold: 10,
    disregardVelocityThreshold: (type, self)=>Math.floor(0.5 * (type === "x" ? self.element.clientWidth : self.element.clientHeight)),
    pressThreshold: 8,
    diagonalSwipes: false,
    diagonalLimit: 15,
    longPressTime: 500,
    doubleTapTime: 300,
    mouseSupport: true
};
var $89e29f4803ac025e$export$2e2bcd8739ae039 = $89e29f4803ac025e$var$TinyGesture;
let $89e29f4803ac025e$var$passiveIfSupported = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, "passive", {
        get: function() {
            $89e29f4803ac025e$var$passiveIfSupported = {
                passive: true
            };
        }
    }));
} catch (err) {}


function $79e354e0ba85f923$export$25bca1bc22cc4f64(target) {
    let swiped = false;
    let startOffset = 0;
    const decelerationOnOverflow = 4;
    const revealWidth = 200;
    const snapWidth = revealWidth / 1.5;
    const gesture = new (0, $89e29f4803ac025e$export$2e2bcd8739ae039)(target);
    // swipe gestures
    gesture.on("panmove", (event)=>{
        if (gesture.animationFrame) return;
        event.preventDefault();
        gesture.animationFrame = window.requestAnimationFrame(()=>{
            let getX = (x)=>{
                if (x < revealWidth && x > -revealWidth) return x;
                if (x < -revealWidth) return (x + revealWidth) / decelerationOnOverflow - revealWidth;
                if (x > revealWidth) return (x - revealWidth) / decelerationOnOverflow + revealWidth;
            };
            const newX = getX(startOffset + gesture.touchMoveX);
            target.style.transform = "translateX(" + newX + "px)";
            if (newX >= snapWidth || newX <= -snapWidth) swiped = newX < 0 ? -revealWidth : revealWidth;
            else swiped = false;
            window.requestAnimationFrame(()=>{
                target.style.transition = null;
            });
            gesture.animationFrame = null;
        });
    });
    gesture.on("panend", ()=>{
        window.cancelAnimationFrame(gesture.animationFrame);
        gesture.animationFrame = null;
        window.requestAnimationFrame(()=>{
            target.style.transition = "transform .2s ease-in";
            if (!swiped) {
                startOffset = 0;
                target.style.transform = null;
            } else {
                startOffset = swiped;
                target.style.transform = "translateX(" + swiped + "px)";
            }
        });
    });
}


const $05556e7da27e597b$var$application = (0, $2AfVR.Application).start();
$05556e7da27e597b$var$application.register("autocomplete", (0, $b932326b47d86c38$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("basket", (0, $5c1e250f0aecced4$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("message", (0, $f8a14f20f89bf263$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("payment", (0, $a2acfda34e5abb9c$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("product", (0, $d6b2f310850c2f46$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("sidebar", (0, $9cca1a06a8a90da9$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("voucher", (0, $d30bacd09465fe91$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("courrier", (0, $5134bda4cc9eef48$export$2e2bcd8739ae039));
$05556e7da27e597b$var$application.register("courrier-pickup", (0, $ea702e2c2ddb4b36$export$2e2bcd8739ae039));
document.addEventListener("DOMContentLoaded", ()=>{
    document.querySelectorAll(".swipe-item").forEach((0, $79e354e0ba85f923$export$25bca1bc22cc4f64));
    var swiper = new Swiper(".mySwiper", {
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        }
    });
});

})();
//# sourceMappingURL=index.js.map
